export const APPLICATION_REQUEST = 'APPLICATION_REQUEST';
export const APPLICATION_SAVE = 'APPLICATION_SAVE';
export const APPLICATION_UPDATE = 'APPLICATION_UPDATE';
export const TOGGLE_EDITHCARE_POPUP = 'TOGGLE_EDITHCARE_POPUP';
